import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const toastError = (error, waitForMs = 5000) => {
    toast.error(error, {
        position: "top-center",
        autoClose: waitForMs,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
}

export const toastSuccess = (success, waitForMs = 2000) => {
    toast.success(success, {
        position: "top-center",
        autoClose: waitForMs,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
}